import React, {ReactNode} from 'react';
import {Box, Typography, Avatar} from '@mui/material';

interface TippCardProps {
    children?: ReactNode;
    curatorImageUrl?: string;
}

const CuratorTippCard = ({ children, curatorImageUrl }: TippCardProps) => {
    return (
        <Box position="relative" maxWidth={400} width="100%" display="inline-block">
            {/* Die eigentliche Card */}
            {children}

            {/* Kopf mit Sprechblase auf der linken Seite */}
            <Box
                position="absolute"
                top={-12}
                right={24}
                display="flex"
                alignItems="flex-start"
                flexDirection="row-reverse"
                zIndex={10}
            >
                <Avatar
                    alt="Tippgeber"
                    src={curatorImageUrl}
                    sx={{
                        width: 96,
                        height: 96,
                        border: '5px solid white',
                        boxShadow: '1px 1px 0 primary',
                        transform: 'rotate(4deg)'
                    }}
                    variant="rounded"
                />
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        right: 48,
                        width: 250,
                        height: 12,
                    }}
                >
                    <Typography
                        sx={{
                            textTransform: 'uppercase',
                            fontWeight: 'medium',
                        }}
                        gutterBottom
                        color={'text.secondary'}
                    >
                        Kuratierte Auswahl
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default CuratorTippCard;
